import React, { useCallback } from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';
import { Box } from '@mui/system';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';

interface MultipleChoiceQuestionProps {
  options: DropdownOption[];
  onChange: (newValue: DropdownOption[]) => void;
  value?: DropdownOption[];
  helperText?: string;
  disabled?: boolean;
}

type Props = MultipleChoiceQuestionProps;

const MultipleChoiceQuestion = ({ options, value, onChange, helperText, disabled }: Props) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const target = event.target as HTMLInputElement;
      const optionId = target.name;
      const isChecked = target.checked;

      if (isChecked) {
        const newOption = options.find((option) => option.id.toString() === optionId.toString());
        if (!newOption) {
          return;
        }

        const newValue = [...(value || []), newOption];
        onChange(newValue);
      } else {
        const newValue = value ? value.filter((x) => x.id.toString() !== optionId.toString()) : [];
        onChange(newValue);
      }
    },
    [onChange, options, value]
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup>
          {options.map((option) => (
            <FormControlLabel
              key={option.id}
              control={
                <Checkbox
                  checked={!!(value || []).find((x) => x.id === option.id)}
                  onChange={handleChange}
                  name={option.id?.toString() || option.name}
                  disabled={disabled}
                />
              }
              label={option.name}
              disabled={disabled}
              sx={{
                color: (theme) => theme.colors.neutral600,
                '.MuiFormControlLabel-label.Mui-disabled': {
                  color: (theme) => theme.colors.neutral600,
                },
              }}
            />
          ))}
        </FormGroup>
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default MultipleChoiceQuestion;
